<template>
  <div :class="$style.bar">
    <div :class="$style.total">
      <span style="margin-bottom: 0.1rem;">PROJECTS</span>
      <span>{{ activeIndex + 1 }}/{{ data.length }}</span>
    </div>
    <ul :class="$style.nav">
      <li
        v-for="(el, index) in data"
        :id="`js-game-menu-${index}`"
        :key="index"
        @click="$emit('click', index)"
      >
        {{ el.title }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default() {
        return []
      },
    },
    activeIndex: { type: Number, default: 0 },
  },
}
</script>

<style lang="less" module>
.bar {
  position: absolute;
  top: @padding-base;
  right: 0;
  width: 2.64rem;
  user-select: none;
}

.total {
  height: 150px;
  font-weight: 700;
  color: #9a9a9a;
  letter-spacing: 0.02rem;
  writing-mode: vertical-rl;

  span {
    display: inline-block;
  }
}

.nav {
  @default-color: #9b9b9b;
  @hover-color: #606060;
  @active-color: @primary;
  @border-color: #eaeaea;

  border-left: 0.02rem solid @border-color;

  li {
    position: relative;
    padding-top: 0.42rem;
    padding-left: 0.29rem;
    color: @default-color;
    cursor: pointer;

    &:not(:global(.active)):hover {
      color: @hover-color;

      &::before {
        background-color: @hover-color;
      }
    }

    &::before {
      .size(0.02rem);
      content: '';
      position: absolute;
      top: 0.49rem;
      left: 0.15rem;
      background-color: @default-color;
    }
  }

  :global(.active) {
    color: @active-color;

    &::before {
      background-color: @active-color;
    }

    &::after {
      .size(0.02rem,0.51rem);
      content: '';
      position: absolute;
      top: 0;
      left: -0.02rem;
      background-color: @active-color;
    }
  }
}
</style>
